import { connect } from "react-redux"
import React, { Component } from "react"
import { createAction } from "redux-actions"
import { browserHistory, Link } from "react-router"
import { Helmet } from "react-helmet";
import Logo from "../../assets/newblacklogo.png"

import {
  login,
  signup,
  check,
  EDIT_USER,
  CLEAR_VIDEOS,
  extConnect
} from "../../actions"
import "./signin.css"
import debounce from 'lodash/debounce'

const mapStateToProps = (state, ownProps) => {
  const { me } = state
  return {
    me,
    redirect: ownProps.viewParams.query.redirect,
    plan: ownProps.viewParams.query.plan,
    action: ownProps.action,
  }
}

class SignIn extends Component {
  constructor() {
    super()
    this.validate = this.validate.bind(this)
    this.validateDebounced = debounce(this.validate, 500, { leading: true, trailing: true })
  }

  componentDidMount() {
    const { dispatch } = this.props

    window.gapi.signin2.render('my-signin2', {
      'scope': 'profile email',
      'width': 235,
      'height': 42,
      'longtitle': true,
      'theme': 'dark',
      'onsuccess': (googleUser) => {
          const id_token = googleUser.getAuthResponse().id_token;
          const profile = googleUser.getBasicProfile();
          const email = profile.getEmail()

          dispatch(
            extConnect(
              id_token,
              email,
              'google'
            )
          ).then(user => {
            googleUser.disconnect();
            this.done(user)
          })
      },
      'onfailure': (e) => {
        console.log("failure! ", e)
      }
    });
  }

  compononentWillUnmount() {
    this.unmounted = true
  }
  
  validate(e) {
    if (this.unmounted || !this.username || !this.password) {
      return
    }
    this.props.dispatch(check(this.username.value, this.password.value))
  }

  done(user) {
    const { viewParams, plan } =  this.props
    const { query } = viewParams
    const { error, user_name } = user
    if (error) {
      return
    }
    console.log("Creating... ", user_name)

    if (plan) {

      const key = process.env.REACT_APP_STRIPE_KEY
      const props = {
        billingAddressCollection:'auto',
        clientReferenceId: user_name,
        items: [{
          plan: plan,
          quantity: 1
        }],
        successUrl: `https://${key.includes('test_') ? 'staging.' : ''}streamable.com?alert=${plan}&checkout=true&src_internal=signup-login-page`,
        cancelUrl: `https://${key.includes('test_') ? 'staging.' : ''}streamable.com?checkout=false&src_internal=cancelled-stripe-checkout`
      }
      if (user_name.includes('@')) {
        props['customerEmail'] = user_name; 
      }
      window.Stripe(key).redirectToCheckout(props);
      return
    }

    if (this.props.redirect) {
      window.location = decodeURIComponent(this.props.redirect)
      return
    } 
    browserHistory.push('/')
  }

  render() {
    const { dispatch, me, action } = this.props
    const self = this
    return (
      <div className="container signin">
        <Helmet>
          <title>{action == "signup" ? "Sign up": "Log in"} - Streamable</title>
          <meta name="description" content={action == "signup" ? "Sign up for a free Streamable account.": "Log in to your existing Streamable account."}></meta>
          <link rel="canonical" href={`https://streamable.com/${action}`} />
        </Helmet>
        <div className="row">
          <div className="signin-box col flex-middle">
            <a href="/">
              <img className="logo" src={Logo} role="presentation" />
            </a>
            <div className="card">
              <div id="my-signin2" style={{'margin': '0px auto 10px auto'}}></div>
              <button className="btn facebook-button" onClick={() => {
                console.log("Facebook button clicked")
                  window.FB.login((response) => {
                    let authResponse = window.FB.getAuthResponse()
                    const authToken = authResponse.accessToken
                    window.FB.api('/me', { locale: 'en_US', fields: 'name, email' },
                      function(response) {
                        dispatch(
                          extConnect(
                            authToken,
                            response.email,
                            'facebook'
                          )
                        ).then(user => {
                          self.done(user)
                        })
                      }
                    );
                  }, {scope: "email"})
                }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 216" className="_5h0m" color="#ffffff">
                <path fill="#ffffff" d="M204.1 0H11.9C5.3 0 0 5.3 0 11.9v192.2c0 6.6 5.3 11.9 11.9
                11.9h103.5v-83.6H87.2V99.8h28.1v-24c0-27.9 17-43.1 41.9-43.1
                11.9 0 22.2.9 25.2 1.3v29.2h-17.3c-13.5 0-16.2 6.4-16.2
                15.9v20.8h32.3l-4.2 32.6h-28V216h55c6.6 0 11.9-5.3
                11.9-11.9V11.9C216 5.3 210.7 0 204.1 0z"></path>
                </svg>
                <span className="facebook-text">Continue with Facebook</span>
              </button>
              <div className="separator"><span>or</span></div>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  dispatch(createAction(CLEAR_VIDEOS)())
                  if (action === "signup") {
                    dispatch(
                      signup(
                        this.username.value,
                        this.password.value,
                        this.username.value
                      )
                    ).then(user => {
                      this.done(user)
                    })
                  } else {
                    dispatch(
                      login(this.username.value, this.password.value)
                    ).then(user => {
                      this.done(user)
                    })
                  }
                }}
              >
                <div className="form-group">
                  <input
                    type="username"
                    className="form-control"
                    placeholder={
                      action === "signup"
                        ? "Email address"
                        : "Email or username"
                    }
                    onChange={this.validateDebounced}
                    ref={node => {
                      this.username = node
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    onChange={this.validateDebounced}
                    ref={node => {
                      this.password = node
                    }}
                  />
                </div>
                {me.message != null
                  ? <div
                      className={`${me.error ? "error" : "info"} signin-alert`}
                    >
                      {me.message}
                    </div>
                  : ""}
                {action !== "signup"
                  ? <Link
                      to="/recover"
                      className="forgot-password float-left"
                    >
                      Reset Password
                    </Link>
                  : ""}
                <button
                  type="submit"
                  className={`blue-button float-right ${me.loggingIn ? 'disabled': ''}`}
                  disabled={me.loggingIn}
                >
                  {action === "login" ? "Log In" : "Sign Up"}
                </button>
                <div style={{ clear: "both" }} />
              </form>
            </div>
            {this.props.plan ? '' :
              action !== "signup"
                ?
                <div className="footer">
                  Don't have an account?&nbsp;&nbsp; 
                  <Link
                    onClick={() => this.props.dispatch(createAction(EDIT_USER)({ error: null, message: null }))}
                    to={`/signup${typeof window !== "undefined" ? window.location.search : ""}`}
                    activeClassName="active"
                  >
                    Sign Up
                  </Link>
                </div>
                :
                <div className="footer">
                  Already have an account?&nbsp;&nbsp;
                  <Link
                    onClick={() => this.props.dispatch(createAction(EDIT_USER)({ error: null, message: null }))}
                    to={`/login${typeof window !== "undefined" ? window.location.search : ""}`}
                    activeClassName="active"
                  >
                    Log In
                  </Link>
                </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(SignIn)
